import { CarrierSearchInterface } from '@/types';
import { SegmentModeType } from '@/types/api-types';
import { getPreferredIdentifier } from '@/utils/helpers';

interface CarrierOption {
  label: string;
  value: string;
  type: SegmentModeType;
}

/**
 * Maps carriers to options for use in Select/Combobox components
 */
export const mapCarriersToOptions = (carriers: CarrierSearchInterface[]) => {
  return carriers.reduce(
    (groupedCarriers, carrier) => {
      const preferredIdentifier = getPreferredIdentifier(carrier.identifiers);
      const value = `${preferredIdentifier?.type} ${preferredIdentifier?.value}`;

      const carrierOption = {
        label: `${carrier.name} (${preferredIdentifier?.value})`,
        value,
        type: carrier.type,
        id: carrier.id,
        tracking: carrier.tracking,
      };

      if (!(carrier.type in groupedCarriers)) {
        // eslint-disable-next-line no-param-reassign
        groupedCarriers[carrier.type] = [];
      }

      groupedCarriers[carrier.type].push(carrierOption);

      return groupedCarriers;
    },
    {} as Record<SegmentModeType, CarrierOption[]>,
  );
};
